import {
  Button,
  Divider,
  Grid,
  GridColumn,
  Spinner
} from "@modernatx/ui-kit-react";
import React from "react";

import { PaymentForm } from "@/components/PaymentForm";
import InvoiceDueDateComponent from "@/components/Payments/AutoPayModal/InvoiceDueDateComponent";
import PaymentMethodCard from "@/components/Payments/AutoPayModal/PaymentMethodCard";
import { useSavedPaymentMethods } from "@/hooks/useSavedPaymentMethod";
import { PaymentMethod, SchedulePayTypes } from "@/types/PaymentMethod";

interface SchedulePayModalContentProps {
  modalType: SchedulePayTypes;
  invoiceId?: string | string[];
  showAddPaymentMethod?: boolean;
  paymentFormSubmitRef?: React.MutableRefObject<
    (() => Promise<PaymentMethod | undefined>) | undefined
  >;
  selectedPayment?: PaymentMethod | string | undefined;
  setSelectedPayment?: React.Dispatch<
    React.SetStateAction<PaymentMethod | string | undefined>
  >;
}

export const SchedulePayModalContent: React.FC<
  SchedulePayModalContentProps
> = ({
  modalType,
  invoiceId,
  showAddPaymentMethod,
  paymentFormSubmitRef,
  selectedPayment,
  setSelectedPayment
}) => {
  const {
    allPaymentMethods,
    defaultPaymentMethod,
    error: paymentMethodError,
    loading
  } = useSavedPaymentMethods();

  if (loading) {
    return (
      <Grid>
        <GridColumn sx={{ alignItems: "center" }}>
          <Spinner />
        </GridColumn>
      </Grid>
    );
  }

  return (
    <>
      <InvoiceDueDateComponent modalType={modalType} invoiceId={invoiceId} />
      <PaymentMethodCard
        defaultPaymentMethod={defaultPaymentMethod}
        allPaymentMethods={allPaymentMethods}
        paymentMethodError={paymentMethodError}
        selectedPayment={selectedPayment}
        setSelectedPayment={setSelectedPayment}
      />
      <Grid sx={{ mt: "spacing-7" }}>
        <GridColumn>
          {showAddPaymentMethod && (
            <PaymentForm
              setSubmitRef={(fn) => {
                if (paymentFormSubmitRef) {
                  paymentFormSubmitRef.current = fn;
                }
              }}
            />
          )}
        </GridColumn>
      </Grid>
      {modalType === SchedulePayTypes.IndividualInvoicesUpdate && (
        <Grid
          sx={{
            alignItems: "center",
            textAlign: "center",
            mt: "spacing-7"
          }}
        >
          <GridColumn>
            <Divider sx={{ mb: "spacing-5" }} />
            <Button variant="subtle">Delete scheduled payment</Button>
            <Divider sx={{ mt: "spacing-5" }} />
          </GridColumn>
        </Grid>
      )}
    </>
  );
};
